module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"products":{"action":"Find funds","empty_state":"Add funds that you find interesting to your watchlist to keep an eye on them. You will then be informed about important updates.","title":"Watchlist"}}}}}}}')
  delete Component.options._Ctor
}
